export default "__VITE_ASSET__BPa79ULs__"